import Weather from './Weather'

(function(){
    const $weatherInfos = document.querySelectorAll('.weather-info')
    $weatherInfos.forEach($wi => new Weather($wi)) 
})()